import React, { useState } from "react";

export default function ManualAttendance() {
  const [email, setEmail] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [employeeData, setEmployeeData] = useState(null);
  const [loading, setLoading] = useState(false);

  const markAttendance = async () => {
    if (!email) {
      showModal("❌ Please enter an email.");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch("https://attendance-api.elitewebpro.com/api/attendance/manual", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ employee_email: email }),
      });

      const data = await res.json();
      showModal(data.message, data.employee || null);

      if (data.success) setEmail("");
    } catch (err) {
      console.error(err);
      showModal("❌ Server error. Please try again.", null);
    } finally {
      setLoading(false);
    }
  };

  const showModal = (message, employee = null) => {
    setModalMessage(message);
    setEmployeeData(employee);
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
    setModalMessage("");
    setEmployeeData(null);
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Manual Attendance</h2>

      <div style={styles.formContainer}>
        <input
          type="email"
          placeholder="Enter employee email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={styles.input}
        />

        <button onClick={markAttendance} disabled={loading} style={styles.button}>
          {loading ? <span className="loader"></span> : "Mark Attendance"}
        </button>
      </div>

      {/* Modal */}
      {modalVisible && (
        <div style={styles.overlay}>
          <div style={styles.modal} className="modal-animate">
            <p style={styles.modalMessage}>{modalMessage}</p>

            {employeeData && (
              <div style={styles.employeeCard}>
                {employeeData.image && (
                  <img
                    src={`https://attendance-api.elitewebpro.com${employeeData.image}`}
                    alt={employeeData.name}
                    style={styles.profileImage}
                  />
                )}
                <div style={styles.employeeName}>{employeeData.name}</div>
                <div style={styles.employeeEmail}>{employeeData.email}</div>
              </div>
            )}

            <button onClick={closeModal} style={styles.closeButton}>
              Close
            </button>
          </div>
        </div>
      )}

      {/* Loader Animation CSS */}
      <style>
        {`
          .loader {
            width: 20px;
            height: 20px;
            border: 3px solid #fff;
            border-top: 3px solid transparent;
            border-radius: 50%;
            animation: spin 0.7s linear infinite;
            display: inline-block;
          }

          @keyframes spin {
            to { transform: rotate(360deg); }
          }

          .modal-animate {
            animation: fadeScale 0.3s ease-out;
          }

          @keyframes fadeScale {
            0% { opacity: 0; transform: scale(0.7); }
            100% { opacity: 1; transform: scale(1); }
          }

          @media (max-width: 480px) {
            #modal {
              width: 90%;
            }
          }
        `}
      </style>
    </div>
  );
}

/* =======================
      STYLES
======================== */
const styles = {
  container: {
    textAlign: "center",
    padding: "20px",
    maxWidth: "500px",
    margin: "auto",
  },

  heading: {
    fontSize: "24px",
    marginBottom: "20px",
    fontWeight: "600",
  },

  formContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    alignItems: "center",
    width: "100%",
  },

  input: {
    padding: "12px",
    width: "90%",
    maxWidth: "350px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    fontSize: "16px",
    outline: "none",
  },

  button: {
    padding: "12px 20px",
    background: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    cursor: "pointer",
    width: "90%",
    maxWidth: "200px",
  },

  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.45)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },

  modal: {
    background: "#fff",
    padding: "25px",
    borderRadius: "12px",
    textAlign: "center",
    width: "90%",
    maxWidth: "350px",
    boxShadow: "0px 5px 20px rgba(0,0,0,0.3)",
  },

  modalMessage: {
    fontSize: "16px",
    marginBottom: "15px",
  },

  employeeCard: {
    marginTop: "15px",
    padding: "10px",
    borderRadius: "10px",
    background: "#f9f9f9",
  },

  profileImage: {
    width: "90px",
    height: "90px",
    borderRadius: "50%",
    marginBottom: "10px",
    objectFit: "cover",
    border: "3px solid #007bff",
  },

  employeeName: {
    fontWeight: "600",
    marginBottom: "5px",
  },

  employeeEmail: {
    fontSize: "14px",
    color: "#555",
  },

  closeButton: {
    marginTop: "15px",
    background: "#ff4d4d",
    color: "#fff",
    border: "none",
    padding: "10px 18px",
    borderRadius: "8px",
    cursor: "pointer",
  },
};
